const productTypeList = [
  'luggage',
  'meal',
  'insurance',
  'lugInsurance',
  'itinerary',
  'viphall',
  'seat',
  'cardCoupon'
]

const intlProductTypeList = [
  'luggage',
  'meal',
  'insurance',
  'itinerary',
  'seat'
]

const productConfig = {
  luggage: {
    title: '差异化行李',
    icon: require('../img/extra-luggage-v2.png'),
    className: 'luggage',
    span: 6,
    trackName: '行李'
  },
  meal: {
    title: '特色餐饮',
    icon: require('../img/extra-meal-v2.png'),
    className: 'meal',
    span: 8,
    trackName: '餐食'
  },
  insurance: {
    title: '保险',
    icon: require('../img/extra-insurance-v2.png'),
    className: 'insurance',
    span: 6,
    trackName: '保险'
  },
  lugInsurance: {
    title: '行李险',
    icon: require('../img/extra-insurance-v2.png'),
    className: 'insurance',
    span: 6,
    trackName: '保险'
  },
  viphall: {
    title: '贵宾厅',
    icon: require('../img/extra-guest-v2.png'),
    className: 'guest',
    span: 6,
    trackName: '贵宾厅'
  },
  itinerary: {
    title: '邮寄行程单',
    icon: require('../img/extra-email-v2.png'),
    className: 'itinerary',
    trackName: '行程单'
  },
  seat: {
    title: '预选座值机',
    icon: require('../img/extra-seat-v2.png'),
    className: 'seat',
    trackName: '选座'
  },
  cardCoupon: {
    title: '卡券',
    icon: require('../img/extra-card-v2.png'),
    className: 'cardCoupon',
    trackName: '卡券'
  }
}
export { productTypeList, intlProductTypeList, productConfig }
